const getters = {
  persons: state => state.persons,
}

export default getters;
